















































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import Axios from 'axios'
import { IColumnDef } from '@/interfaces/ag-grid'
import { TrackFields } from '@/constants'
import { Track } from '@/classes/track'
import * as _ from 'lodash'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import { Playlist } from '@/classes/playlist'
import { numberFilter } from '@/filters'
import { TrackSelectWizardTargets } from '@/store/modules/trackselectwizard'
import { HistoryViewMixin } from '@/mixins'

enum VIEWS {
  Start = 'start',
  AddTracks = 'add_tracks'
}

@Component({
  components: {
    ReorderTable: require('@/components/ReorderTable').default,
    TrackSelectWizard: require('@/components/TrackSelectWizard').default,
    TrackFieldEditorModal: require('@/components/TrackFieldEditorModal').default
  }
})
export default class EditTracks extends Mixins(HistoryViewMixin) {
  @Prop()
  tracks: Track[]

  @Prop()
  selectedPlaylist: Playlist

  view: VIEWS = VIEWS.Start
  model: Track[] = this.tracks
  selectedTracks: Track[] = []
  loading: boolean = false
  allowSelection: boolean = true
  trackSelectWizardTarget: TrackSelectWizardTargets = TrackSelectWizardTargets.PlaylistEditTracks
  selectedIndexes: number[] = []

  columnDefs: IColumnDef[] = [
    {
      field: TrackFields.Title,
      rowDrag: true
    },
    {
      field: TrackFields.Artist
    }
  ]

  get removeLabel(): string {
    let s = `Remove`

    if (this.selectedTracks.length > 0) s += ` (${numberFilter(this.selectedTracks.length)})`

    return s
  }

  shuffle() {
    this.model = _.shuffle(this.model)

    window.addUsageStat(USAGE_STAT_FEATURES.ManagePlaylist, 'shuffle')
  }

  toggleSelectionMode(override: boolean) {
    this.allowSelection = override === undefined ? !this.allowSelection : override
  }

  onTrackEditModalOpen() {
    this.removeEventListeners()
  }

  onTrackEditModalClose() {
    this.addEventListeners()
  }

  onTrackEditModalSave(track: Track) {
    this.selectedTracks = []

    this.model.splice(this.model.findIndex(t => t._id === track._id), 1, track)
  }

  async loadTrackEditor() {
    this.$store.commit('library/setSelectedTracksByTrack', this.selectedTracks)

    await this.$router.push({
      name: 'track editor transform'
    })
  }

  async removeSelected() {
    if (this.loading || this.selectedIndexes.length === 0) return

    this.loading = true

    for (const i of this.selectedIndexes.sort().reverse()) {
      this.model.splice(i, 1)
    }

    await this.save(`Removed ${this.selectedIndexes.length} track${this.selectedIndexes.length === 1 ? '' : 's'}`)

    this.selectedTracks = []
  }

  async onAddTracks() {
    const newTracks: Track[] = this.$store.getters['library/selectedTracks']

    if (this.loading || newTracks.length === 0) return

    this.goToView(VIEWS.Start)

    this.loading = true

    newTracks.forEach(t => this.model.push(t))

    await this.save(`Added ${newTracks.length} track${newTracks.length === 1 ? '' : 's'}`)
  }

  async save(message: string) {
    this.loading = true

    if (typeof message !== 'string') message = 'Playlist saved'

    try {
      const res = await Axios.post('/playlist/reorder', {
        id: this.selectedPlaylist._id,
        trackIds: this.model.map(x => x._id)
      })

      if (res && res.data && res.data.playlists) {
        this.$store.commit('library/replacePlaylists', res.data)
      }

      this.$buefy.notification.open(message)

      this.toggleSelectionMode(true)

      this.$emit('save')
    } catch (error) {
      console.error(error)
    }

    this.loading = false
  }

  async onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Delete') {
      await this.removeSelected()
    }
  }

  addEventListeners() {
    window.addEventListener('keydown', this.onKeyDown)
  }

  removeEventListeners() {
    window.removeEventListener('keydown', this.onKeyDown)
  }

  created() {
    this.addEventListeners()
  }

  destroyed() {
    this.removeEventListeners()
  }

  @Watch('view')
  watchView() {
    if (this.view === VIEWS.Start) {
      this.selectedTracks = []
    }
  }
}
